export const DOG = 'Собака';
export const CAT = 'Кошка';
export const DOG_TYPE = '1';
export const CAT_TYPE = '2';
export const PET_NAMES = {
    [DOG_TYPE]: DOG,
    [CAT_TYPE]: CAT,
};
